<template>
    <div class="modal fade" id="completeTaskModal" role="dialog"
         aria-labelledby="ccompleteTaskModallLabel" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="ccompleteTaskModallLabel">{{$t('tasks.taskCompletion')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form @submit="onSave" v-if="!isSaving">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <div class="font-weight-bold">{{$t('tasks.timeToFinish')}}</div>
                                <div>
                                    <div class="d-flex">
                                        <input type="number" class="form-control" v-model="hours" min="0" />
                                        <span style="height: fit-content; align-self: center;">{{$t('hours')}}</span>
                                    </div>
                                    <div class="d-flex">
                                        <input type="number" class="form-control" v-model="minutes" min="0" />
                                        <span style="height: fit-content; align-self: center;">{{$t('minutes')}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="font-weight-bold">{{$t('coordinations.comment')}}</div>
                                <textarea class="form-control" v-model="comment" name="text" />
                            </div>

                            <div class="col-md-12 bmd-form-group">
                                <div class="font-weight-bold">{{$t('tasks.attachment')}}</div>
                                <div>
                                    <div class="mb-2" v-for="item in model.attachments" :key="_uid+item.fileName">
                                        <file-crud :file="item"
                                                   :showDescription="false"
                                                   @removeFile="onRemoveFile"
                                                   :editable="!item.id"
                                                   :type="item.docTypeCode">
                                        </file-crud>
                                    </div>

                                    <div v-if="!model.attachments.length || (model.attachments[model.attachments.length-1].content || model.attachments[model.attachments.length-1].id)">
                                        <button class="btn btn-primary ml-0" @click="addAtachment">
                                            <i class="fa fa-plus"></i>
                                            {{$t('add')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" v-if="!isLockedForEdit">
                        <button type="submit" class="btn btn-primary">{{$t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.cancel')}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { File, Task } from '../../models/models';
    import FileCrud from '../common/FileCRUD';
    import taskService from '../../services/tasks.service';

    export default {
        components: {
            FileCrud
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            value: Number,
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isSaving: false,
                comment: '',
                model: new Task(),
                hours: 0,
                minutes: 0
            };
        },
        methods: {
            onSave(e) {
                e.preventDefault();

                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.save();
                    }
                });
            },
            save() {
                this.isSaving = true;
                let data = new FormData();
                data.append('id', this.value);
                data.append('answer', this.comment);
                data.append('hoursToFinish', this.hours);
                data.append('minutesToFinish', this.minutes);

                // files
                if (this.model.attachments.length) {
                    for (let index = 0; index < this.model.attachments.length; index++) {
                        const attachment = this.model.attachments[index];
                        data.append(`files`, attachment.content);
                    }
                }

                taskService
                    .complete(data)
                    .then(result => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('updateSuccess'),
                            text: ''
                        });
                        this.$emit('updated', this);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        });
                    })
                    .then(() => {
                        this.hide();
                    });
            },
            onClose() {
                this.$emit('onClose', { ...this });
                this.isSaving = false;
                this.comment = '';
                this.hours = 0;
                this.minutes = 0;
                this.model = new Task();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            addAtachment() {
                this.model.attachments.push(new File());
            },
            onRemoveFile(_id) {
                this.model.attachments = this.model.attachments.filter(x => x._id !== _id);
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.comment = '';
                    this.hours = 0;
                    this.minutes = 0;
                    this.model = new Task();
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px;
    }
</style>
